export default function INFP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “میانجی”</h1>{" "}
          <p>
            شخصیت&zwnj;های میانجی آرمانگرایانی واقعی هستند، همیشه به دنبال
            نشانه&zwnj;هایی از خوبی در حتی بدترین افراد و حوادث می&zwnj;گردند و
            در جستجوی راه&zwnj;هایی برای بهتر کردن اوضاع هستند. ممکن است
            میانجی&zwnj;گران را افرادی آرام، کم&zwnj;حرف یا حتی خجالتی تصور کرد،
            اما شعله&zwnj;ای درونی و شور و شوقی دارند که واقعاً می&zwnj;تواند
            بدرخشد. گونه شخصیتی میانجی فقط 4% جمعیت را تشکیل می&zwnj;دهد و
            متأسفانه خطر بروز سوءتفاهم برای آنها بالا است - اما وقتی افراد همفکر
            خود را پیدا می&zwnj;کنند تا وقتشان را با آنها بگذرانند، هماهنگی که
            احساس می&zwnj;کنند سرچشمه شادی و الهام&zwnj;بخشی است.
          </p>{" "}
          <div className="scene"></div>{" "}
          <p>
            میانجی&zwnj;گران براساس اصول خود عمل می&zwnj;کنند تا منطق، هیجان، یا
            عملی بودن مسائل. آنها در هنگام تصمیم&zwnj;گیری برای حرکت رو به جلو،
            در پی افتخار، زیبایی، اخلاق و فضیلت هستند - میانجی&lrm;گران به واسطه
            خلوص نیت خود هدایت می&zwnj;شوند نه پاداش و مجازات. افراد دارای گونه
            شخصیتی میانجی به&zwnj;درستی به این کیفیت افتخار می&zwnj;کنند، اما
            همه افراد محرک پشتوانه این احساسات را درک نمی&zwnj;کنند و این امر
            می&zwnj;تواند به انزوا منجر شود.
          </p>{" "}
          <blockquote>
            <p>
              هر چیزی که طلا باشد برق نمی&zwnj;زند؛ همه کسانی که سرگردان هستند
              گم نشده&zwnj;اند؛ چیزهای قدیمی که نیرومند باشند از ریخت
              نمی&zwnj;افتند؛ یخبندان به ریشه&zwnj;های عمیق نمی&zwnj;رسد.
            </p>{" "}
            <footer>J. R. R. Tolkien</footer>
          </blockquote>{" "}
          <h2>
            ما می&zwnj;دانیم چه کسانی هستیم، اما نمی&zwnj;دانیم ممکن است چه
            کسانی باشیم
          </h2>{" "}
          <p>
            این ویژگی&zwnj;ها در بهترین حالت خود افراد دارای گونه شخصیتی میانجی
            را قادر به برقراری ارتباط عمیق با دیگران، صحبت کردن به&zwnj;سادگی با
            زبان استعاره و مثل، و درک و ایجاد نمادهایی برای در میان گذاشتن
            ایده&zwnj;های خود می&zwnj;سازد. میزان قوت این سبک ارتباطی شهودی تا
            سطح آثار هنری است و به همین دلیل جای تعجب نیست که بسیاری از
            میانجی&zwnj;گران معروف شاعر، نویسنده و بازیگر بوده&zwnj;اند. درک خود
            و جایگاه خود در جهان برای شخصیت میانجی مهم است، و آنها این
            ایده&zwnj;ها را با غرق کردن خود در کارشان بررسی می&zwnj;کنند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              میانجی&zwnj;گران استعدادی برای ابراز خویش، آشکار کردن زیبایی و
              اسرار خود از طریق استعاره&zwnj;ها و شخصیت&zwnj;های داستانی دارند.
            </p>
          </blockquote>{" "}
          <p>
            توانایی زبانی میانجی&zwnj;گران در حد زبان مادری&zwnj;شان متوقف
            نمی&zwnj;ماند - آنها در هنگام آموختن زبان دوم (یا سوم!) نیز مستعد
            تلقی می&zwnj;شوند. استعداد میانجی&zwnj;گران در برقراری ارتباط به میل
            آنها برای هماهنگی نیز یاری می&zwnj;رساند و به این شخصیت&zwnj;ها کمک
            می&zwnj;کند وقتی مسیر خود را پیدا کردند رو به جلو حرکت کنند.
          </p>{" "}
          <h2>
            به حرف تعداد زیادی از مردم گوش بده، اما با تعداد اندکی صحبت کن
          </h2>{" "}
          <p>
            میانجی&zwnj;گران بر خلاف گونه&zwnj;های شخصیتی اجتماعی&zwnj;تر توجه
            خود را تنها به چند نفر و کاری ارزشمند معطوف می&zwnj;کنند - زیرا اگر
            به مسائل زیادی توجه نشان دهند، انرژی خود را از دست می&zwnj;دهند و
            حتی در جهانی مبتلا به این همه بدی که نمی&zwnj;توانند آن را از میان
            ببرند دچار افسردگی می&zwnj;شوند. چنین منظره&zwnj;ای برای دوستان
            میانجی&zwnj;گران غم&zwnj;انگیز است چرا که آنها به روی شاداب این
            افراد وابسته هستند.
          </p>{" "}
          <p>
            اگر میانجی&zwnj;گران خوب مراقب نباشند ممکن است در حین این تلاش نسبت
            به خود بی&zwnj;توجه شوند و از رسیدگی به نیازهای روزانه زندگی غفلت
            نمایند. میانجی&zwnj;گران اغلب به تفکر عمیق می&zwnj;پردازند و از تأمل
            ذهنی و فلسفی بیش از هر گونه شخصیتی دیگری لذت می&zwnj;برند. اگر
            شخصیت&zwnj;های میانجی کنترل نشوند ممکن است کم&zwnj;کم تماس خود را از
            دست بدهند و به "گوشه&zwnj;نشینی" روی بیاورند و بازگرداندن آنها به
            جهان واقعی مستلزم صرف انرژی زیاد از طرف دوستان یا شریک زندگی آنها
            خواهد بود.
          </p>{" "}
          <p>
            خوشبختانه، محبت، خلاقیت، نوع&zwnj;دوستی و آرمان&zwnj;گرایی
            میانجی&zwnj;گران همیشه مانند گل در فصل بهار دوباره باز خواهد گشت، و
            به خودشان و کسانی که آنها را دوست دارند نه منطق و سود، بلکه نوعی
            جهان&zwnj;بینی اعطا می&zwnj;کند که هر کجا که بروند الهام&zwnj;بخش
            شفقت، مهربانی و زیبایی است.
          </p>
        </article>
      </div>
    </div>
  );
}
